import globalConfig from '@dogfy/config'

export default {
  ...globalConfig,
  dogfyLinks: {
    signUp: { path: { es: '/nuevo-plan', fr: '/fr/nouveau-plan', it: '/it/nuovo-piano' } },
    legal: [
      { langKey: 'legalWarning', path: { es: '/legal', fr: '/fr/legale', it: '/it/legale' } },
      { langKey: 'termsAndConditions', path: { es: '/condiciones', fr: '/fr/conditions', it: '/it/condizioni' } },
      { langKey: 'cookiesPolicy', path: { es: '/privacidad', fr: '/fr/privacite', it: '/it/privacy' } },
    ],
  },
  daysInTrialCycle: 14,
  daysInStandardCycle: 28,
  prepaidPayment: 'PAYMENT01',
  dailyGramsThresholdForOrders: 500,
  // TODO: Add DPD once implemented.
  deliveryCompanies: {
    es: {
      impackta: { type: 'standard', price: 0, icon: 'truck' },
      seur: { type: 'premium', price: 5, icon: 'snowflake' },
    },
    it: {
      impackta: { type: 'standard', price: 0, icon: 'truck' },
      brt: { type: 'standard', price: 0, icon: 'truck' },
    },
    fr: {
      impackta: { type: 'standard', price: 0, icon: 'truck' },
      dpd: { type: 'standard', price: 0, icon: 'truck' },
    },
  },
  allowedEditableOrderStatuses: ['scheduled', 'paid'],
  activityOptions: ['lazy', 'normal', 'active'],
  feedingOptions: ['fodder', 'wet', 'barf', 'cooked'],
  appetiteOptions: ['selective', 'gourmet', 'glutton'],
  knownDogShapes: ['skinny', 'normal', 'fat'],
  adultEstimatedSizes: ['xs', 's', 'm', 'l', 'xl'],
  reasonsForPause: [
    { code: 'dog-does-not-like-food', type: 'nutritional' },
    { code: 'food-bad-for-dog', type: 'nutritional' },
    { code: 'needs-special-food-permanently', type: 'nutritional' },
    { code: 'needs-special-food-temporarily', type: 'nutritional' },
    { code: 'leftover-food', type: 'nutritional' },
    { code: 'mixed-diet', type: 'nutritional' },
    { code: 'dog-passed-away', type: 'nutritional' },
    { code: 'wrong-content-order', type: 'service' },
    { code: 'out-of-home', type: 'service' },
    { code: 'thawed-order', type: 'service' },
    { code: 'bad-experience', type: 'service' },
    { code: 'price-too-high', type: 'price-and-deliveries' },
    { code: 'self-managing-orders', type: 'price-and-deliveries', outdated: true },
    { code: 'freezer-space', type: 'price-and-deliveries' },
    { code: 'holidays', type: 'price-and-deliveries' },
  ],
  couponDiscountForPrice: 'NOPAUSE30X',
  paidAdditionalDeliveryFee: 5,
  countriesEligibleToBeContacted: ['es', 'it'],
  mixedPlanAllowedCountriesWhenPausing: ['es', 'fr', 'it'],
  oAuthProviders: {
    google: {
      baseUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
      clientId: import.meta.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
      redirectUri: `${import.meta.env.VUE_APP_CUST_URL}/login/google`,
      label: 'Google',
      icon: 'google-color',
    },
    fb: {
      baseUrl: 'https://www.facebook.com/v22.0/dialog/oauth',
      clientId: import.meta.env.VUE_APP_FB_OAUTH_CLIENT_ID,
      redirectUri: `${import.meta.env.VUE_APP_CUST_URL}/login/fb`,
      label: 'Facebook',
      icon: 'facebook-color',
    },
    apple: {
      baseUrl: 'https://appleid.apple.com/auth/authorize',
      redirectUri: `${import.meta.env.VUE_APP_API_URL}/auth/apple/callback`,
      clientId: import.meta.env.VUE_APP_APPLE_OAUTH_CLIENT_ID,
      label: 'Apple',
      icon: 'apple-color',
    },
  },
}
